<template>
  <div class="py-4 px-4">
    <highcharts :options="chartOptions"></highcharts>
  </div>

</template>

<script>

export default {
  props:
  {
    legenda: String,
    unidadeMedida: String,
    dados: Array,
    tipo: {
      type: String,
      default: 'column'
    },
  },
  data() {

    return {
      chartOptions: {
        chart: {
          type: this.tipo
        },
        title: {
          text: this.legenda
        },

        xAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          type: 'category',
        },
        yAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          title: {
            text: this.unidadeMedida
          }
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          column: {
            borderWidth: 0
          },
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: '{point.y}'
            }
          }
        },
        series: [{
          name: 'Avaliações',
          colorByPoint: true,
          data: this.dados
        }]
      }
    }

  }
}
</script>
